import { Tab, TabPanel, Tabs, TabsList } from '@mui/base'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import classNames from 'classnames'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useCurrentRoute } from '../../../hooks/getReduxData/useCurrentRoute'
import { setDirection, tranRoutesSelector } from '../../../redux/slices/tranRoutes'
// import { fetchRoutesStops } from '../../../redux/thunks/select'
import { fetchSchedule } from '../../../redux/thunks/tranRoutes'
import { findClosestTime } from '../../../utils/time'
import ArrowDownIcon from '../../reusable/Icons/ArrowDownIcon'
import KeyValueInfo from '../../reusable/Info/KeyValueInfo'
import NoData from '../../reusable/Titles/Subtitles/NoData'

const RoutesTabs = () => {
  // const { routesStops } = useSelector(selectSelector)
  const { route_id, direction, day_type_id, schedule } = useSelector(tranRoutesSelector)
  const dispatch = useDispatch()
  const handleTab = (e, newValue) => {
    dispatch(setDirection(newValue))
  }
  const { distance = '', has_two_ways = false } = useCurrentRoute(route_id) // from_stop_id, to_stop_id
  // const fromRoutesStop = getRoutesStop(from_stop_id, routesStops)
  // const toRoutesStop = getRoutesStop(to_stop_id, routesStops)
  // const fromRoutesStop = getRoutesStop(from_stop_id, schedule)
  // const toRoutesStop = getRoutesStop(to_stop_id, schedule)
  const fromRoutesStop = schedule?.[0] || {}
  const toRoutesStop = schedule?.[schedule.length - 1] || {}

  useEffect(() => {
    // dispatch(fetchRoutesStops({ direction, route_id }))
    dispatch(fetchSchedule())
  }, [dispatch, direction, route_id, day_type_id])

  const RoutePanel = () => (
    <>
      {schedule?.length ? (
        <>
          <div className="content_header">
            {/* {fromRoutesStop && (
              <KeyValueInfo infoKey="Початкова" infoValue={fromRoutesStop.name_uk} />
            )}
            {toRoutesStop && (
              <KeyValueInfo infoKey="Кінцева" infoValue={toRoutesStop.name_uk} />
            )} */}
            {fromRoutesStop && (
              <KeyValueInfo infoKey="Початкова" infoValue={fromRoutesStop.names['uk'] || ''} />
            )}
            {toRoutesStop && (
              <KeyValueInfo infoKey="Кінцева" infoValue={toRoutesStop.names['uk'] || ''} />
            )}
            {distance && <KeyValueInfo infoKey="Відстань" infoValue={distance + ' км'} />}
            {/* {routesStops?.length > 0 && (
              <KeyValueInfo infoKey="Зупинок всього" infoValue={routesStops.length} />
            )} */}
            {schedule?.length > 0 && (
              <KeyValueInfo infoKey="Зупинок всього" infoValue={schedule.length} />
            )}
          </div>

          <div className="route_accordions">
            {/* {routesStops.map(({ stop_id, name_uk }, ind) => (
              <Accordion key={stop_id} defaultExpanded={ind === 0} className="route_accordion">
                <AccordionSummary className="accordion_summary" expandIcon={<ArrowDownIcon />}>
                  <span className="route_num">{ind + 1}</span>
                  <span className="route_station">{name_uk}</span>
                </AccordionSummary>
              </Accordion>
            ))} */}

            {schedule.map(({ ex_id, names, schedules = [] }, ind) => (
              <Accordion key={ex_id} defaultExpanded={ind === 0} className="route_accordion">
                <AccordionSummary className="accordion_summary" expandIcon={<ArrowDownIcon />}>
                  <span className="route_num">{ind + 1}</span>
                  <span className="route_station">{names['uk'] || ''}</span>
                </AccordionSummary>
                <AccordionDetails className="accordion_details">
                  {/* ['11:25', '16:32', '19:23'] */}
                  {schedules.length > 0
                    ? schedules.map((time) => (
                        <div
                          key={ex_id + time}
                          className={classNames('route_time', {
                            closest: time === findClosestTime(schedules),
                          })}
                        >
                          {time}
                        </div>
                      ))
                    : 'Інформація про час прибуття відсутня'}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </>
      ) : (
        <NoData msg="На обраному маршруті відсутня інформація про зупинки" />
      )}
    </>
  )

  return (
    <div className="routes_tabs">
      <Tabs value={direction} onChange={handleTab} className="routes_tab_component">
        <TabsList>
          <Tab value="forward" className="routes_tab_button">
            Прямий маршрут
          </Tab>
          <Tab
            value="backward"
            disabled={!has_two_ways}
            // disabled
            className={classNames('routes_tab_button', {
              disabled: !has_two_ways,
              // disabled: true,
            })}
          >
            Зворотній маршрут
          </Tab>
        </TabsList>

        <TabPanel value="forward" className="routes_tab_content">
          <RoutePanel />
        </TabPanel>

        <TabPanel value="backward" className="routes_tab_content">
          <RoutePanel />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default RoutesTabs
